import {
	Ai,
	Calendar,
	Exchange,
	Finance,
	MoneyBagMove,
	Mortarboard,
	MoveBack,
	SquareEdit,
} from '../../../shared/assets/icons';

export const sidebarMenu = [
	{
		id: 1,
		name: 'NavBarAuthId1',
		items: [
			{
				id: 1,
				path: '/overview',
				label: 'NavBarAuthId2',
				icon: SquareEdit,
			},
			{
				id: 2,
				path: '/income',
				label: 'NavBarAuthId3',
				icon: MoveBack,
			},
			{
				id: 3,
				path: '/expenses',
				label: 'NavBarAuthId4',
				icon: MoneyBagMove,
			},
			{
				id: 4,
				path: '/transactions',
				label: 'NavBarAuthId5',
				icon: Exchange,
			},
			{
				id: 5,
				path: '/goals',
				label: 'NavBarAuthId6',
				icon: Finance,
			},
		],
	},
	{
		id: 2,
		name: 'NavBarAuthId7',
		items: [
			{
				id: 1,
				path: '/ai-advisor',
				label: 'NavBarAuthId8',
				icon: Ai,
			},
		],
	},
	{
		id: 3,
		name: 'NavBarAuthId10',
		items: [
			{
				id: 1,
				path: '/education-hub',
				label: 'NavBarAuthId11',
				icon: Mortarboard,
			},
			{
				id: 2,
				path: '/calendar-view',
				label: 'NavBarAuthId12',
				icon: Calendar,
			},
		],
	},
];
